import { render, staticRenderFns } from "./ProtocolsTable.vue?vue&type=template&id=25dd59d3&scoped=true"
import script from "./ProtocolsTable.vue?vue&type=script&lang=js"
export * from "./ProtocolsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd59d3",
  null
  
)

export default component.exports